import { BaseNode } from './base/BaseNode';

export class Doc extends BaseNode {
  constructor() {
    super('doc');
  }

  get schema() {
    return {
      content: 'block+',
    };
  }
}
